import { ReactNode } from 'react';
import { contextFactory } from '@frontend/design-system';

export const [StepIndexContext, useStepIndexContext] = contextFactory<number>(
  'useStepIndexContext must be used within a StepIndexProvider'
);

export const StepIndexProvider = ({ children, index }: { children: ReactNode; index: number }) => (
  <StepIndexContext.Provider value={index}>{children}</StepIndexContext.Provider>
);
